import { useState } from "react";

const FIELD_OPTIONS = ["All Fields", "Title", "Author", "Journal", "Abstract"];

const BOOLEAN_OPTIONS = ["AND", "OR", "NOT"];

export default function QueryBox({ query, setQuery, onSearch, picoQuery }) {
  const [field, setField] = useState(FIELD_OPTIONS[0]);
  const [booleanOp, setBooleanOp] = useState(BOOLEAN_OPTIONS[0]);
  const [term, setTerm] = useState("");

  const addToQuery = () => {
    if (!term.trim()) return;

    const fragment = `${field !== "All Fields" ? `${field}:` : ""}'${term}'`;

    setQuery((prev) => (prev ? `${prev} ${booleanOp} ${fragment}` : fragment));

    setTerm("");
  };

  const clearQuery = () => setQuery("");

  return (
    <div className="bg-base-100 space-y-4 rounded-lg border p-4 shadow-sm">
      <h2 className="text-lg font-semibold">Search Term Query Builder</h2>

      {typeof picoQuery === "string" && (
        <div className="rounded-lg border border-base-300 bg-base-200/40 p-3">
          <div className="mb-2 flex items-center justify-between">
            <span className="text-sm font-semibold">PICO Query (read-only)</span>
            <button
              type="button"
              className="btn btn-xs btn-outline"
              onClick={() => {
                navigator.clipboard?.writeText(picoQuery);
              }}
            >
              Copy
            </button>
          </div>
          <textarea
            className="textarea textarea-bordered min-h-[72px] w-full bg-base-100"
            value={picoQuery}
            readOnly
          />
        </div>
      )}

      <div className="flex flex-wrap gap-2">
        <input
          type="text"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          placeholder="Enter search term"
          className="input input-bordered flex-1"
        />

        <select
          className="select select-bordered"
          value={booleanOp}
          onChange={(e) => setBooleanOp(e.target.value)}
        >
          {BOOLEAN_OPTIONS.map((b) => (
            <option key={b}>{b}</option>
          ))}
        </select>

        <button className="btn btn-primary" onClick={addToQuery}>
          Add
        </button>
      </div>
      <div>
        <label className="font-medium">Query Box</label>
        <textarea
          className="textarea textarea-bordered min-h-[80px] w-full mt-2"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="'breast cancer' AND 'breast neoplasms'"
        />
        <div className="mt-2 flex gap-2">
          <button className="btn btn-sm btn-error" onClick={clearQuery}>
            Clear Query
          </button>

          <button className="btn btn-sm btn-accent" onClick={onSearch}>
            Search
          </button>
        </div>
      </div>
    </div>
  );
}
